import { useRouteMatch } from 'react-router-dom';
import BackButtonView from './back_button_view';

const routesWithoutBack = {
  exact: [
    '/',
    '/offer',
  ],
  rest: [
    '/self_exclude',
    '/bv_cashier',
    '/my_transactions',
    '/account',
    '/safer_gambling',
    '/refer_a_friend',
    '/preferences',
    '/personal_details',
    '/login',
    '/customer_inbox',
    '/search',
    '/pages/contact-us',
    '/pages/request-callback',
    '/quick_deposit',
  ],
};

const BackButtonContainer = () => {
  const exactMatch = useRouteMatch({
    path: routesWithoutBack.exact,
    exact: true,
  });

  const match = useRouteMatch({
    path: routesWithoutBack.rest,
  });

  if (match || exactMatch) return null;
  return <BackButtonView />;
};

export default BackButtonContainer;
